import React, { useState } from 'react';
import { Anchor, Drawer, Button } from 'antd';

import './outside-common.css'

const { Link } = Anchor;

function OutsideHeader() {

    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };

    return (
        <div className="container-fluid">
            <div className="outsideHeader">
                <div className="logo">
                    <a href="htt://">管理資訊系統</a>
                </div>
                <div className="pcVisible">
                    <Anchor targetOffset="10">
                        <Link href="#index" title="首頁" />
                        <Link href="#about" title="關於我們" />
                        <Link href="#feature" title="能力培養" />
                        <Link href="#works" title="培訓規劃" />
                        <Link href="#fqa" title="職涯發展" />
                        <Link href="#pricing" title="教育目標" />
                        <Link href="#contact" title="常用網站" />
                    </Anchor>
                </div>
                <div className="mobileVisible">
                    <Button type="primary" onClick={showDrawer}><i className="fas fa-bars"></i></Button>
                    <Drawer
                        title="功能清單"
                        placement="right"
                        closable={false}
                        onClose={onClose}
                        visible={visible}
                    >
                        <Anchor targetOffset="10">
                            <Link href="#index" title="首頁" />
                            <Link href="#about" title="關於我們" />
                            <Link href="#feature" title="能力培養" />
                            <Link href="#works" title="培訓規劃" />
                            <Link href="#fqa" title="職涯發展" />
                            <Link href="#pricing" title="教育目標" />
                            <Link href="#contact" title="常用網站" />
                        </Anchor>
                    </Drawer>
                </div>

            </div>
        </div>
    )

}


export default OutsideHeader